import { module } from "angular";
import env from "@gtmhub/env/env.module";
import files from "@gtmhub/files/module";
import { TeamService, TeamsActions } from ".";

const mod = module("teams-core", [env, "ngFileUpload", files]);
mod.service("TeamService", TeamService);
mod.service("TeamsActions", TeamsActions);
export default mod.name;
